import {
  PENGELOLAAN_KINERJA_KS_PEGAWAI_PATH,
  PENGELOLAAN_KINERJA_PS_PATH as NEW_PENGELOLAAN_KINERJA_PS_PATH,
} from 'app/KinerjaShared/constants/path'

const tabNames = [
  'Hasil Kerja Utama',
  'Hasil Kerja Tambahan',
  'Perilaku Kerja',
  'Pengajuan',
]

const tabNamesSubmitted = [
  'Hasil Kerja Utama',
  'Hasil Kerja Tambahan',
  'Perilaku Kerja',
]

const reviewTabNames = [
  'Hasil Kerja Utama',
  'Hasil Kerja Tambahan',
  'Perilaku Kerja',
  'Persetujuan',
]

const tabNamesV2 = [
  'Praktik Kinerja',
  'Pengembangan Kompetensi',
  'Perilaku Kerja',
  'Rangkuman',
]

const buktiKaryaCategoryMappings = [
  {
    key: 'ARTIKEL',
    iconName: 'newspaper',
    title: 'Artikel',
  },
  {
    key: 'MATERI_AJAR',
    iconName: 'text_snippet',
    title: 'Materi Ajar',
  },
  {
    key: 'BAHAN_AJAR',
    iconName: 'text_snippet',
    title: 'Bahan Ajar',
  },
  {
    key: 'DOKUMEN_TEKNIS',
    iconName: 'addchart',
    title: 'Dokumen Teknis',
  },
  {
    key: 'KEPEMIMPINAN_SEKOLAH',
    iconName: 'groups',
    title: 'Kepemimpinan Sekolah',
  },
  {
    key: 'PRAKTIK_PEMBELAJARAN',
    iconName: 'book',
    title: 'Praktik Pembelajaran',
  },
  {
    key: 'PRAKTIK_BAIK',
    iconName: 'playlist_add_check',
    title: 'Praktik Baik',
  },
  {
    key: 'RPP',
    iconName: 'list',
    title: 'RPP/Modul Ajar',
  },
  {
    key: 'KARYA_LAINNYA',
    iconName: 'web',
    title: 'Karya Lainnya',
  },
  {
    key: 'KARYA_LAINNYA',
    iconName: 'web',
    title: 'Lainnya',
  },
]

/**
 * @deprecated
 * Use PENGELOLAAN_KINERJA_KS_PEGAWAI_PATH from app/KinerjaShared/constants/path instead
 *
 */
const PENGELOLAAN_KINERJA_KS_PATH = PENGELOLAAN_KINERJA_KS_PEGAWAI_PATH

/**
 * @deprecated
 * Use PENGELOLAAN_KINERJA_PS_PATH from app/KinerjaShared/constants/path instead
 *
 */
const PENGELOLAAN_KINERJA_PS_PATH = NEW_PENGELOLAAN_KINERJA_PS_PATH

export {
  tabNames,
  tabNamesSubmitted,
  reviewTabNames,
  tabNamesV2,
  buktiKaryaCategoryMappings,
  PENGELOLAAN_KINERJA_KS_PATH,
  PENGELOLAAN_KINERJA_PS_PATH,
}
